module.exports = __webpack_public_path__ + "static/media/klara-av.bc42a582.mp3";